import { Swal } from '@/plugins/sweetalert2'
import { DismissReason } from '@/plugins/sweetalert2'
import lang from '@/plugins/lang'
import store from '@/store'

function getClientTimezone() {
    if (!Intl) {
        return null
    }

    let format = Intl.DateTimeFormat()

    return format.resolvedOptions().timeZone
}

function getExpiresTime(expDays) {
    let date = new Date();

    date.setTime(date.getTime() + (expDays * 24 * 60 * 60 * 1000));

    return date.toUTCString()
}

function fireAlertTimezone({ clientTz, userTz }) {
    return Swal.fire({
        title: lang.t('alert:timezone_wrong.title'),
        html: lang.t('alert:timezone_wrong.text', { replace: { clientTz, userTz } }),
        icon: 'question',
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: lang.t('alert:timezone_wrong.button_confirm'),
        cancelButtonText: lang.t('alert:timezone_wrong.button_cancel'),
    }).then(result => {
        if (result.isConfirmed) {
            window.location.href = '/' + store().prefixUrl + '/account'
        }

        if (result.dismiss === DismissReason.CANCEL) {
            document.cookie = `ignore_timezone_diff=; expires=${getExpiresTime(10)};`
        }
    })
}

let showAlert = true

export function ignoreTimezoneDiff() {
    showAlert = false
}

export function alertIfTimezoneDiff() {
    if (!showAlert || document.cookie.indexOf('ignore_timezone_diff=') >= 0) {
        return
    }

    let clientTimezone = getClientTimezone()

    if (clientTimezone && store().isAuthenticate && store().auth.timezone !== clientTimezone) {
        fireAlertTimezone({clientTz: clientTimezone, userTz: store().auth.timezone })
    }
}
